import "./App.css";
import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";
import Home from "./pages/Home";
import CreatePost from "./pages/CreatePost";
import Post from "./pages/Post";
import Registration from "./pages/Registration";
import Login from "./pages/Login";
import PageNotFound from "./pages/PageNotFound";
import Profile from "./pages/Profile";
import ChangePassword from "./pages/ChangePassword";

import { AuthContext } from "./helpers/AuthContext";
import { useState, useEffect } from "react";
import axios from "axios";
import TopPost from "./pages/TopPost";

<style>
	@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
</style>;

function App() {
	const [authState, setAuthState] = useState({
		username: "",
		id: 0,
		status: false,
	});

	useEffect(() => {
		axios
			.get("https://trilog-social-media.herokuapp.com/auth/auth", {
				headers: {
					accessToken: localStorage.getItem("accessToken"),
				},
			})
			.then((response) => {
				if (response.data.error) {
					setAuthState({ ...authState, status: false });
				} else {
					setAuthState({
						username: response.data.username,
						id: response.data.id,
						status: true,
					});
				}
			});
	}, []);

	const logout = () => {
		localStorage.removeItem("accessToken");
		setAuthState({ username: "", id: 0, status: false });
	};

	return (
		<div className="App">
			<AuthContext.Provider value={{ authState, setAuthState }}>
				<Router>
					<div className="navbar">
						<div className="links">
							{!authState.status ? (
								<>
									<Link to="/login"> Sign In</Link>
									<Link to="/registration"> Sign Up</Link>
								</>
							) : (
								<>
									<Link to="/"> Home </Link>
									<Link to="/createpost"> New Post </Link>
									{/* <Link to="/topPost"> Top Post </Link> */}
								</>
							)}
							<h1 className="s_name">
								<b>TriloG</b>
							</h1>
						</div>

						<div className="loggedInContainer">
							<h1> {authState.username} </h1>
							{authState.status && <button onClick={logout}> Sign Out</button>}
						</div>
					</div>
					<Switch>
						<Route path="/" exact component={Home} />
						<Route path="/createpost" exact component={CreatePost} />
						<Route path="/post/:id" exact component={Post} />
						<Route path="/registration" exact component={Registration} />
						<Route path="/login" exact component={Login} />
						<Route path="/profile/:id" exact component={Profile} />
						<Route path="/changepassword" exact component={ChangePassword} />
						<Route path="/topPost" exact component={TopPost} />
						{/* Error Page route */}
						<Route path="*" exact component={PageNotFound} />
					</Switch>
				</Router>
			</AuthContext.Provider>
		</div>
	);
}

export default App;
